import React, { Component, Fragment } from "react";
import { Button } from "../components/Button";
import { Paging } from "../components/Paging";
import { Table, TableHead, TableBody, Col, HeaderCell } from "../components/Table";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { pesticideInstructorOperationRightsOptions, pesticideInstructorEducationAreaOptions } from "../constants";
import "./SearchResults.css";
import { FormattedMessage } from "react-intl";
import MunicipalityContext from "../MunicipalityContext";

export class SearchResults extends Component {

  static contextType = MunicipalityContext;

  render() {
    const {
      changePage,
      currentPage,
      pageSize,
      results,
      searching,
      searchError,
      sortColumn,
      sortDirection,
      totalRows,
      updateSort,
      locale,
    } = this.props;

    const spinner = (
      <div className='spinnerContainer'>
        <LoadingSpinner />
      </div>
    );
    if (!searching && !results) return "";

    if (searchError) {
      return (
        <div className='searchError'>
          <FormattedMessage id='pesticideInstructorSearch.searchError' />
        </div>
      );
    }


    const municipalities = this.context;

    const municipalityNames = municipalities.reduce((obj, municipality) => {
      obj[municipality.kuntaKoodi] =
        locale === "fi" ? municipality.kuntaNimi : municipality.kuntaNimiSv;
      return obj;
    }, {});

    const paging = (
      <Paging
        itemsLength={totalRows}
        perPage={pageSize}
        activePage={currentPage}
        changePage={changePage}
      >
        {({ totalPages, activePage, goBack, goForward }) => (
          <div className='paging'>
            <Button link onClick={goBack} disabled={activePage === 0}>
              <FormattedMessage id='common.previous' />
            </Button>
            <div className='pagesCount'>
              {activePage + 1} / {totalPages || 1}
            </div>
            <Button link onClick={goForward} disabled={activePage >= totalPages - 1}>
              <FormattedMessage id='common.next' />
            </Button>
          </div>
        )}
      </Paging>
    );

    const drawResultsHeadingFinished = (
      <div className="resultHeading" aria-live="assertive">
        <FormattedMessage
          id="common.results"
          values={{
            results: <span className="resultCount">{totalRows}</span>,
          }}
        />
      </div>
    );

    const drawResultsHeadingSearching = (
      <div className='resultHeading'>
        <FormattedMessage id='common.searching' />
      </div>
    );

    const findLabelByEducationAreaId = (values, options) => {
      var labels = [];

      for (var value of values) {
        var label = pesticideInstructorEducationAreaOptions[locale].find(x => x.value === value)
        if (label != null) {
          labels.push(label.label);
        }
      }

      return labels.join(', ');
    };

    const generateKey = row => {
      return `${row.testaajanTunnus}${row.koulutusalaId}`;
    };

    return (
      <Fragment>
        {searching ? drawResultsHeadingSearching : drawResultsHeadingFinished}
        {paging}
        <Table>
          <TableHead sortColumn={sortColumn} sortDirection={sortDirection} updateSort={updateSort}>
            <HeaderCell name='nimi'>
              <FormattedMessage id='pesticideInstructorSearch.name' />
            </HeaderCell>
            <HeaderCell name='TestaajanTunnus'>
              <FormattedMessage id='pesticideInstructorSearch.number' />
            </HeaderCell>
            <HeaderCell name='kuntaKoodi'>
              <FormattedMessage id='pesticideInstructorSearch.municipality' />
            </HeaderCell>
            <HeaderCell name='puhelinnumero'>
              <FormattedMessage id='pesticideInstructorSearch.phone' />
            </HeaderCell>
            <HeaderCell name='sahkoposti'>
              <FormattedMessage id='pesticideInstructorSearch.email' />
            </HeaderCell>
            <HeaderCell name='patevyydet'>
              <FormattedMessage id='common.competency' />
            </HeaderCell>
            <HeaderCell name='koulutusalaId'>
              <FormattedMessage id='pesticideInstructorSearch.educationAreas' />
            </HeaderCell>
          </TableHead>
          {searching ? (
            <tbody>
              <tr>
                <td colSpan='7'>{spinner}</td>
              </tr>
            </tbody>
          ) : (
            <TableBody rows={results}>
              {rows =>
                rows.map(row => (
                  <tr key={generateKey(row)}>
                    <Col label='pesticideInstructorSearch.name'>{row.nimi}</Col>
                    <Col label='pesticideInstructorSearch.number'>{row.testaajanTunnus}</Col>
                    <Col label='pesticideInstructorSearch.municipality'>
                      {municipalityNames[row.kuntaKoodi]}
                    </Col>
                    <Col label='pesticideInstructorSearch.phone'>{row.puhelinnumero}</Col>
                    <Col label='pesticideInstructorSearch.email'>{row.sahkoposti}</Col>
                    <Col label='common.competency'>
                      <FormattedMessage id={pesticideInstructorOperationRightsOptions.find(x => x.value === row.patevyydet).label} />
                    </Col>
                    <Col label='pesticideInstructorSearch.educationAreas'>
                      {findLabelByEducationAreaId(row.koulutusalaId)}
                    </Col>
                  </tr>
                ))
              }
            </TableBody>
          )}
        </Table>
        {paging}
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/PesticideInstructorSearch/SearchResults.js